const STORAGE_KEY = 'financialSupportProgramWizard';
const PROGRAMS_STORAGE_KEY = 'financialSupportPrograms';

export function readFinancialSupportWizard() {
  if (typeof window === 'undefined') {
    return {};
  }

  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    return {};
  }
}

export function writeFinancialSupportWizard(nextValue) {
  if (typeof window === 'undefined') {
    return;
  }

  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(nextValue));
}

export function mergeFinancialSupportWizard(patch) {
  const currentValue = readFinancialSupportWizard();
  const nextValue = { ...currentValue, ...patch };
  writeFinancialSupportWizard(nextValue);
  return nextValue;
}

export function clearFinancialSupportWizard() {
  if (typeof window === 'undefined') {
    return;
  }

  window.sessionStorage.removeItem(STORAGE_KEY);
}

export function loadFinancialSupportProgramIntoWizard(program) {
  if (!program) {
    return;
  }

  writeFinancialSupportWizard({
    basicInfo: program.basicInfo || {},
    contributionRules: program.contributionRules || {},
    plans: Array.isArray(program.plans) ? program.plans : [],
    editingProgramId: program.id || null,
  });
}

export function readFinancialSupportPrograms() {
  if (typeof window === 'undefined') {
    return [];
  }

  try {
    const raw = window.localStorage.getItem(PROGRAMS_STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (error) {
    return [];
  }
}

export function writeFinancialSupportPrograms(programs) {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(PROGRAMS_STORAGE_KEY, JSON.stringify(programs));
}
